<template>
  <div class="live-content">
    <div class="live-left">
      <div class="live-box">
        <div class="live-tab">
          <!-- tab栏 -->
          <div class="tab">
            <i class="iconfont">&#xe629;</i>
            <span>视频直播</span>
          </div>
          <div class="video-origin-list" v-if="coverInfo.tv && coverInfo.tv.length > 0" :class="{ 'align-left' : coverInfo.tv && coverInfo.tv.length > 8}">
            <div class="list">
              <div class="video-origin" v-for="item in coverInfo.tv" @click="chooseTv(item)" :key="item.id">
                <img :title="item.username" :src="item.face" alt :class="curTv && item.id == curTv.id ? 'active' : ''" />
              </div>
            </div>
          </div>
        </div>
        <div class="live-iframe">
          <!-- 内嵌主播视频 -->
          <iframe v-if="liveUrl && ![3,11].includes(coverInfo.state)" id="videoIframe" :src="liveUrl" width="748" height="428" frameborder="no" scrolling="no" allow="autoplay; fullscreen" allowfullscreen></iframe>
          <div class="tv-players" v-else-if="coverInfo.tv && coverInfo.tv.length > 1 && !liveUrl">
            <div class="tv-title">尊上请您选择幸运主播</div>
            <div class="tv-list-wrap">
              <div class="tv-elect" v-for="(item, index) in coverInfo.tv" :key="index" @click="chooseTv(item)">
                <div class>
                  <img :src="item.face" />
                </div>
                <div class="tv-username">
                  {{ item.username }}
                </div>
                <div class="tv-abel" v-if="item.label" v-html="handleLabel(item.label)"></div>
              </div>
            </div>
          </div>
          <div v-else-if="!coverInfo.tv || coverInfo.tv.length == 0 || [3,11].includes(coverInfo.state)" class="empty-tv">
            <div class="empty-wrap">
              <div class="title">
                <span>{{ coverInfo.league }}</span>
                <span class="bo">BO{{ coverInfo.bo }}</span>
                <span>{{ coverInfo.start_time | timeFormat }}</span>
              </div>
              <div class="content">
                <div class="home">
                  <div class="logo">
                    <img :src="coverInfo.home_logo" alt="" @error="logoImgError" />
                  </div>
                  <p>{{ coverInfo.home_team_name }}</p>
                  <div class="history">
                    <template v-for="(item, idx) in homeSmallHistory">
                      <img :key="idx" v-if="item.is_win" src="../../assets/images/gaming/player-success-icon.png" alt="" />
                      <img v-else :key="'fail' + idx" src="../../assets/images/gaming/player-fail-icon.png" alt="">
                    </template>
                  </div>
                </div>
                <div class="mid">
                  <div>暂无直播</div>
                  <div>VS</div>
                  <div>近期表现</div>
                </div>
                <div class="home">
                  <div class="logo">
                    <img :src="coverInfo.away_logo" @error="logoImgError" alt="" />
                  </div>
                  <p>{{ coverInfo.away_team_name }}</p>
                  <div class="history">
                    <template v-for="(item, idx) in awaySmallHistory">
                      <img :key="idx" v-if="item.is_win" src="../../assets/images/gaming/player-success-icon.png" alt="" />
                      <img v-else :key="'fail' + idx" src="../../assets/images/gaming/player-fail-icon.png" alt="">
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <!-- 178广告  30秒弹出-->
            <ad-popup></ad-popup>
        </div>
        <!-- 赛事即时信息 -->
        <div class="game-info">
          <slot name="gameInfo"></slot>
        </div>
      </div>
    </div>
    <div class="live-right">
      <Chatroom :curTv="curTv" :coverInfo="coverInfo"/>
    </div>
  </div>
</template>

<script>
// import Chatroom from '@/components/chatroom/index.vue'
import Chatroom from '@/components/chatroom-v2/index.vue'
import adPopup from "@/components/components/adPopup";
import dayjs from 'dayjs'
export default {
  name: 'LivePlayer',
  components: {
    Chatroom,
    adPopup
  },
  props: {
    coverInfo: {
      type: Object
    },
    curTv: {
      type: [Object, null]
    },
    homeSmallHistory: {
      type: Array
    },
    awaySmallHistory: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  filters: {
    timeFormat(val) {
      return dayjs(val * 1000).format('YYYY-MM-DD HH:mm')
    }
  },
  computed: {
    liveUrl () {
      if (this.curTv && this.curTv.id) {
        return COMMOND.VIDEO_URL + this.curTv.id
      }
      return ''
    }
  },
  methods: {
    handleLabel(label) {
      return label.replace(",", "<br>").replace("，", "<br>");
    },
    chooseTv (tv) {
      if (!this.curTv || this.curTv.id !== tv.id) {
        // this.curTv = tv
        this.$emit('update', tv)
      }
    },
    logoImgError (e) {
      if (this.$route.params.type === 'lol') {
        e.target.src = require('@/assets/images/gaming/lol.png')
      }
      if (this.$route.params.type === 'csgo') {
        e.target.src = require('@/assets/images/gaming/csgo.png')
      }
      if (this.$route.params.type === 'dota2') {
        e.target.src = require('@/assets/images/gaming/dota.png')
      }
      if (this.$route.params.type === 'kog') {
        e.target.src = require('@/assets/images/gaming/kog.png')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.live-content {
  width: 1020px;
  margin: 0 auto;
  display: flex;
  .live-left {
    width: 748px;
    .live-tab {
      display: flex;
      .tab {
        flex: 1;
        color: #FF7888;
        background-color: #636363;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
      }
      .video-origin-list {
        flex: 1;
        max-width: 374px;
        display: flex;
        background: #2B2B2B;
        overflow-y: auto;
        justify-content: center;
        &.align-left {
          justify-content: left;
        }
        /* 滚动条凹槽的颜色 */
        *::-webkit-scrollbar-track-piece {
          background-color: #f8f8f8;
          border-radius: 2em;
        }
        /* 滚动条的宽度 */
        *::-webkit-scrollbar {
          width: 3px;
          height: 3px;
        }
        /* /滚动条的背景色 圆角等设置/ */
        *::-webkit-scrollbar-thumb {
          background-color: #dddddd;
          background-clip: padding-box;
          border-radius: 2em;
        }
        /* 滚动条的鼠标移上去效果 */
        *::-webkit-scrollbar-thumb:hover {
          background-color: #bbb;
        }
        .list {
          display: inline-flex;
          padding: 0 20px;
        }
        .video-origin {
          width: 40px;
          height: 40px;
          padding: 6px;
          cursor: pointer;
          img {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            &.active {
              border: 1px dashed #fec501;
            }
          }
        }
      }
    }
    .live-iframe {
      min-height: 428px;
      position: relative;
      background-color: #343434;
      .tv-players {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        .tv-title {
          margin: 68px 0;
          font-size: 16px;
          color: #fff;
        }
        .tv-list-wrap {
          white-space: nowrap;
          max-width: 660px;
          overflow: auto;
          margin: 0 auto;
          .tv-elect {
            width: 116px;
            display: inline-block;
            padding: 0 14px;
            cursor: pointer;
            vertical-align: top;
            color: #fff;
            &:hover {
              img {
                border: 2px solid #fec501;
              }
            .tv-username {
              color: #fec501;
            }
            }
            img {
              width: 85px;
              height: 85px;
              border-radius: 50%;
              border: 2px solid #fff;
              display: block;
            }
            .tv-username {
              padding: 17px 0;
              font-size: 13px;
            }
          }
        }
      }
    }
    .game-info {
      height: 134px;
      background: #2B2B2B;
    }
  }
}

.empty-tv {
  padding: 116px 153px;
  background: url('../../assets/images/gaming/empty-bg.png') no-repeat;
  background-size: 100%;
  .empty-wrap {
    border-radius: 10px;
    overflow: hidden;
    background: rgba(0,0,0,.6);
    .title {
      display: flex;
      background: #E65668;
      height: 46px;
      line-height: 46px;
      font-size: 14px;
      color: #fff;
      padding: 0 18px;
      gap: 30px;
      span {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:last-child {
          text-align: right;
        }
      }
      .bo {
        width: 50px;
        text-align: center;
        flex: none;
      }
    }
    .content {
      padding: 36px 30px;
      display: flex;
      gap: 30px;
      .home, .away {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        .logo  {
          width: 40px;
          height: 40px;
          border-radius: 5px;
          background: #fff;
          padding: 2px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 5px;
          }
        }
        p {
          margin-top: 20px;
          line-height: 24px;
          font-size: 14px;
          color: #fff;
        }
        .history {
          display: flex;
          gap: 4px;
          margin-top: 10px;
          img {
            width: 22px;
            height: 22px;
          }
        }
      }
      .mid {
        line-height: 24px;
        color: #BABABA;
        font-size: 14px;
        div {
          margin-bottom: 20px;
          text-align: center;
        }
      }
    }
  }
}
</style>
